/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  FETCH_USERS: "[Users] Fetch users",
  FETCH_USERS_SUCCESS: "[Users] Fetch users success",
  FETCH_USERS_FAILED: "[Users] Fetch users failed",

  FETCH_A_USER: "[Users] Fetch a user",
  FETCH_A_USER_SUCCESS: "[Users] Fetch a user success",
  FETCH_A_USER_FAILED: "[Users] Fetch a user failed",

  FETCH_A_USER_DETAILS: "[Users] Fetch a user details",
  FETCH_A_USER_DETAILS_SUCCESS: "[Users] Fetch a user details success",
  FETCH_A_USER_DETAILS_FAILED: "[Users] Fetch a user details failed",

  CREATE_USER: "[Users] Create user",
  CREATE_USER_SUCCESS: "[Users] Create user success",
  CREATE_USER_FAILED: "[Users] Create user failed",

  REMOVE_USER: "[Users] Remove current user",

  DISABLE_USER: "[Users] Disable current user",
  DISABLE_USER_SUCCESS: "[Users] Disable current user success",
  DISABLE_USER_FAILED: "[Users] Disable current user failed",

  ENABLE_USER: "[Users] Enable current user",
  ENABLE_USER_SUCCESS: "[Users] Enable current user success",
  ENABLE_USER_FAILED: "[Users] Enable current user failed",

  UPDATE_USER: "[Users] Update user",
  UPDATE_USER_SUCCESS: "[Users] Update user success",
  UPDATE_USER_FAILED: "[Users] Update user failed",

  UPDATE_USER_STATUS: "[User] Update user status",
  UPDATE_USER_STATUS_SUCCESS: "[User] Update user status success",
  UPDATE_USER_STATUS_FAILED: "[User] Update user status failed",

  RESEND_INVITE: "[Users] Resend invite user",
  RESEND_INVITE_SUCCESS: "[Users] Resend invite success",
  RESEND_INVITE_FAILED: "[Users] Resend invite failed",

  DELETE_USER: "[Users] Delete user",
  DELETE_USER_SUCCESS: "[Users]  Delete user success",
  DELETE_USER_FAILED: "[Users]  Delete user failed",

  CLEAR_USER: "[Users] Clear user",
  CLEAR_USER_LIST: "[Users] Clear user list",
  CLEAR_RESENT_INVITE: "[Users] Clear Resent invite",

  FETCH_USER_ROLES: "[Users] Fetch user roles",
  FETCH_USER_ROLES_SUCCESS: "[Users] Fetch user roles success",
  FETCH_USER_ROLES_FAILED: "[Users] Fetch user roles failed",
};
//
// ─── FETCH USER ACTIONS ────────────────────────────────────────────────────
//

export const FetchUser = (
  companyId,
  status,
  page,
  size,
  order,
  query,
  field,
  userId,
  filters,
) => ({
  type: types.FETCH_USERS,
  payload: {
    companyId,
    status,
    page,
    size,
    order,
    query,
    field,
    userId,
    filters,
  },
});
export const FetchUsersSuccess = (list) => ({
  type: types.FETCH_USERS_SUCCESS,
  payload: list,
});
export const FetchUsersFailed = (error) => ({
  type: types.FETCH_USERS_FAILED,
  payload: error,
});
//
// ─── FETCH A USER ACTIONS ────────────────────────────────────────────────────
//

export const FetchAUser = () => ({
  type: types.FETCH_A_USER,
});

export const FetchAUserSuccess = (list) => ({
  type: types.FETCH_A_USER_SUCCESS,
  payload: list,
});

export const FetchAUserFailed = (error) => ({
  type: types.FETCH_A_USER_FAILED,
  payload: error,
});
//
//
// ─── FETCH A USER DETAILS ────────────────────────────────────────────────────
//
export const FetchAUserDetails = (payload) => ({
  type: types.FETCH_A_USER_DETAILS,
  payload,
});

export const FetchAUserDetailSuccess = (list) => ({
  type: types.FETCH_A_USER_DETAILS_SUCCESS,
  payload: list,
});

export const FetchAUserDetailsFailed = (error) => ({
  type: types.FETCH_A_USER_DETAILS_FAILED,
  payload: error,
});

//
//
// ─── CREATE USER ACTIONS ────────────────────────────────────────────────────
//
export const CreateUser = (user) => ({
  type: types.CREATE_USER,
  payload: user,
});
export const CreateUserSuccess = (response) => ({
  type: types.CREATE_USER_SUCCESS,
  payload: response,
});
export const CreateUserFailed = (error) => ({
  type: types.CREATE_USER_FAILED,
  payload: error,
});

//
// ─── REMOVE SINGLE USER ACTIONS ────────────────────────────────────────────────────
//

export const RemoveUser = (id) => ({
  type: types.REMOVE_USER,
  payload: id,
});

//
// ─── DISABLE CURRENT USER ACTIONS ──────────────────────────────────────────
//

export const DisableUser = (id) => ({
  type: types.DISABLE_USER,
  payload: id,
});
export const DisableUserSuccess = (response) => ({
  type: types.DISABLE_USER_SUCCESS,
  payload: response,
});
export const DisableUserFailed = (error) => ({
  type: types.DISABLE_USER_FAILED,
  payload: error,
});

//
// ─── ENABLE CURRENT USER ACTIONS ──────────────────────────────────────────
//

export const EnableUser = (id) => ({
  type: types.ENABLE_USER,
  payload: id,
});
export const EnableUserSuccess = (response) => ({
  type: types.ENABLE_USER_SUCCESS,
  payload: response,
});
export const EnableUserFailed = (error) => ({
  type: types.ENABLE_USER_FAILED,
  payload: error,
});
//
// ─── UPDATE USER ACTIONS ────────────────────────────────────────────────────
//
export const UpdateUser = (user) => ({
  type: types.UPDATE_USER,
  payload: user,
});
export const UpdateUserSuccess = (response) => ({
  type: types.UPDATE_USER_SUCCESS,
  payload: response,
});
export const UpdateUserFailed = (error) => ({
  type: types.UPDATE_USER_FAILED,
  payload: error,
});
//
// ─── UPDATE USER STATUS ─────────────────────────────────────────────────────────
//
export const UpdateUserStatus = (status, userId) => ({
  type: types.UPDATE_USER_STATUS,
  payload: { status, userId },
});
export const UpdateUserStatusSuccess = (response) => ({
  type: types.UPDATE_USER_STATUS_SUCCESS,
  payload: response,
});
export const UpdateUserStatusFailed = (error) => ({
  type: types.UPDATE_USER_STATUS_FAILED,
  payload: error,
});
//
// ─── RESEND INVITE ACTIONS ────────────────────────────────────────────────────
//
export const ResendInvite = (email) => ({
  type: types.RESEND_INVITE,
  payload: email,
});
export const ResendInviteSuccess = (response) => ({
  type: types.RESEND_INVITE_SUCCESS,
  payload: response,
});
export const ResendInviteFailed = (error) => ({
  type: types.RESEND_INVITE_FAILED,
  payload: error,
});

export const ClearResentInvite = () => ({
  type: types.CLEAR_RESENT_INVITE,
});

//
// ─── DELETE USER ACTIONS ────────────────────────────────────────────────────
//
export const DeleteUser = (email) => ({
  type: types.DELETE_USER,
  payload: { email },
});
export const DeleteUserSuccess = (response) => ({
  type: types.DELETE_USER_SUCCESS,
  payload: response,
});
export const DeleteUserFailed = (error) => ({
  type: types.DELETE_USER_FAILED,
  payload: error,
});
export const ClearUser = () => ({
  type: types.CLEAR_USER,
});
export const ClearUserList = () => ({
  type: types.CLEAR_USER_LIST,
});
export const FetchUserRoles = () => ({
  type: types.FETCH_USER_ROLES,
});

export const FetchUserRolesSuccess = (list) => ({
  type: types.FETCH_USER_ROLES_SUCCESS,
  payload: list,
});

export const FetchUserRolesFailed = (error) => ({
  type: types.FETCH_USER_ROLES_FAILED,
  payload: error,
});
